import { joiResolver } from "@hookform/resolvers/joi";
import { ErrorText } from "../errors/ErrorText";
import Joi from "joi";
import React, { useRef, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { appAxios } from "../../axios/axios";
import ReCaptcha from "./Ui/ReCaptcha";
import { v4 as UUIDV4 } from "uuid";
import moment from "moment";
import { getAuthToken } from "../../commonGlobals/functions/localStorage/getUser";
import { LoadingButton } from "./Ui/LoadingButton";

type FormValues = {
  subject: string;
  enquiryDetails: any;
  customerDetails: {
    firstName: string;
    email: string;
    phone: string;
  };
};

const queryFormSchema = Joi.object({
  subject: Joi.string(),
  enquiryDetails: Joi.any().required(),
  customerDetails: Joi.object({
    firstName: Joi.string().required().label("Name"),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .optional()
      .allow("")
      .label("Email"),
    phone: Joi.string().length(10).required().label("Phone"),
  }),
});

export const SendQueryFormComponent: React.FC<{
  formDetails: any;
  subject: string;
  buttonLabel: string;
  popupTitle: string;
  onHide: () => void;
  setFormDetails: () => void;
}> = (props) => {
  const isLoogedIn = getAuthToken();

  const [captchaToken, setCaptchaToken] = useState<string | undefined>(
    undefined
  );
  const reCaptchaRef = useRef<any>();
  const [requestLoading, setRequestLoading] = useState(false);
  const { handleSubmit, register, formState } = useForm<FormValues>({
    resolver: joiResolver(queryFormSchema),
    defaultValues: {
      subject: props.subject,
      enquiryDetails: props.formDetails,
      customerDetails: {
        email: "",
        firstName: "",
        phone: "",
      },
    },
  });

  const onSubmit = async (data: FormValues) => {
    if (data.customerDetails.email.length === 0) {
      data.customerDetails.email = UUIDV4() + "@mailinator.com";
    }

    let myRemark;
    let token;
    if (!captchaToken) {
      console.log("getting token");

      token = await reCaptchaRef.current.executeAsync();
      setCaptchaToken(token);
    }
    if (!captchaToken && !token) {
      return toast.error("Please solve captcha");
    }
    setRequestLoading(true);
    if (data.subject === "Bus Enquiry") {
      const htmlDataForBus = `
      <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Customer Details</h6>
        <div>
          <p><b>Name:</b> ${data.customerDetails.firstName}</p>
          <p><b>Email:</b> ${data.customerDetails.email}</p>
          <p><b>Phone:</b> ${data.customerDetails.phone}</p>
        </div>
        </div>
        <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Enquiry Details</h6>
        <div>
          <p><b>FromCityDetails:</b> ${data.enquiryDetails.fromCityDetails}</p>
          <p><b>ToCityDetails:</b> ${data.enquiryDetails.toCityDetails}</p>
          <p><b>TravelDate:</b> ${moment(
            data.enquiryDetails?.travelDate
          ).format("YYYY-MM-DD")}</p>
        </div>
        </div>`;
      myRemark = htmlDataForBus;
    } else if (data.subject === "Hotel Enquiry") {
      const htmlDataForHotel = `
      <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Customer Details</h6>
        <div>
          <p><b>Name:</b> ${data.customerDetails.firstName}</p>
          <p><b>Email:</b> ${data.customerDetails.email}</p>
          <p><b>Phone:</b> ${data.customerDetails.phone}</p>
        </div>
        </div>
        <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Enquiry Details</h6>
        <div>
          <p><b>City:</b> ${data.enquiryDetails.city}</p>
          <p><b>Rooms:</b> ${data.enquiryDetails.rooms}</p>
          <p><b>Guest:</b> ${data.enquiryDetails.guest}</p>
          <p><b>Category:</b> ${data.enquiryDetails.category}</p>
          <p><b>CheckIn:</b> ${moment(data.enquiryDetails.checkin).format(
            "YYYY-MM-DD"
          )}</p>
          <p><b>CheckOut:</b> ${moment(data.enquiryDetails.checkout).format(
            "YYYY-MM-DD"
          )}</p>
        </div>
        </div>`;
      myRemark = htmlDataForHotel;
    } else if (data.subject === "Train Enquiry") {
      const htmlDataForTrain = `
      <div style = "margin-top: 10px;
      padding: 15px;
      box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
      border: 1px solid #e8e8e8;
      background-color: #ffffff;">
        <h6 style="color: #0076b1">Customer Details</h6>
        <div>
          <p><b>Name:</b> ${data.customerDetails.firstName}</p>
          <p><b>Email:</b> ${data.customerDetails.email}</p>
          <p><b>Phone:</b> ${data.customerDetails.phone}</p>
        </div>
        </div>
        <div style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1 ">Enquiry Details</h6>
        <div>
          <p><b>FromCityDetails:</b> ${data.enquiryDetails.fromCityDetails}</p>
          <p><b>ToCityDetails:</b> ${data.enquiryDetails.toCityDetails}</p>
          <p><b>TravelDate:</b> ${moment(
            data.enquiryDetails?.travelDate
          ).format("YYYY-MM-DD")}</p>
        </div>
        </div>`;
      myRemark = htmlDataForTrain;
    } else if (data.subject === "Insurance Enquiry") {
      const htmlDataForInsurrance = `
      <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Customer Details</h6>
        <div>
          <p><b>Name:</b> ${data.customerDetails.firstName}</p>
          <p><b>Email:</b> ${data.customerDetails.email}</p>
          <p><b>Phone:</b> ${data.customerDetails.phone}</p>
        </div>
        </div>
        <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Enquiry Details</h6>
        <div>
          <p><b>Type:</b> ${data.enquiryDetails.type}</p>
          <p><b>NoOfPax:</b> ${data.enquiryDetails.noOfPax}</p>
          <p><b>DepartureDate:</b> ${moment(
            data.enquiryDetails.departureDate
          ).format("YYYY-MM-DD")}</p>
          <p><b>ReturnDate:</b> ${moment(data.enquiryDetails.returnDate).format(
            "YYYY-MM-DD"
          )}</p>
        </div>
        </div>
        `;
      myRemark = htmlDataForInsurrance;
    } else {
      const htmlDataForCruise = `
      <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Customer Details</h6>
        <div>
          <p><b>Name:</b> ${data.customerDetails.firstName}</p>
          <p><b>Email:</b> ${data.customerDetails.email}</p>
          <p><b>Phone:</b> ${data.customerDetails.phone}</p>
        </div>
        </div>
        <div  style = "margin-top: 10px;
        padding: 15px;
        box-shadow: rgb(192 192 192 / 10%) 0px 8px 24px;
        border: 1px solid #e8e8e8;
        background-color: #ffffff;">
        <h6 style="color: #0076b1">Enquiry Details</h6>
        <div>
          <p><b>Destination:</b> ${data.enquiryDetails.destination}</p>
          <p><b>Nights:</b> ${data.enquiryDetails.nights}</p>
          <p><b>CruiseLines:</b> ${data.enquiryDetails.cruiseLines}</p>
          <p><b>Dates:</b> ${data.enquiryDetails.dates}</p>
        </div>
        </div>
        `;
      myRemark = htmlDataForCruise;
    }

    let dataToBeSend: any;
    let myheaders: any;
    if (isLoogedIn) {
      dataToBeSend = {
        remark: myRemark,
        passengers: [],
        segments: [],
        type: "Other Enquiry",
        subject: data.subject,
      };
      myheaders = {
        "captcha-token": captchaToken ? captchaToken : token,
      };
    } else {
      dataToBeSend = {
        userData: {
          customer: {
            ...data.customerDetails,
            companyName: "default",
            lastName: "",
            panNumber: "",
            gst: "",
          },
          userType: "retail",
        },
        enquiryData: {
          remark: myRemark,
          passengers: [],
          segments: [],
          type: "Other Enquiry",
          subject: data.subject,
        },
      };
      myheaders = {
        "captcha-token": captchaToken ? captchaToken : token,
      };
    }

    try {
      const saveQuery = await appAxios({
        url: "/query/saveEnquiry",
        method: "POST",
        data: dataToBeSend,
        headers: myheaders,
      });

      if (saveQuery?.data?.success) {
        toast.success("Enquiry saved successfully");
        props.setFormDetails();
        props.onHide();
      } else {
        throw saveQuery;
      }
    } catch (error: any) {
      const errorMessage = "Unable to save enquiry!!";
      toast.error(error?.response?.data?.error?.errorMessage || errorMessage);
    } finally {
      setRequestLoading(false);
    }
    reCaptchaRef.current.reset();
    setCaptchaToken(undefined);
  };

  return (
    <>
      <Modal show={true} onHide={props.onHide} centered keyboard>
        <Modal.Header closeButton>
          <Modal.Title>
            {isLoogedIn ? "Please provide your details" : "Create New User"}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <form>
              <div className="row">
                <div className="col-12 my-2">
                  <div className="form-group with-icon">
                    <label className=" mb-0">First Name</label>
                    <input
                      {...register("customerDetails.firstName")}
                      type="text"
                      required
                      className="form-control"
                    />
                    <ErrorText
                      error={
                        formState.errors.customerDetails?.firstName?.message
                      }
                    />
                  </div>
                </div>
                <div className="col-12 my-3">
                  <div className="form-group with-icon">
                    <label className=" mb-0">Phone</label>
                    <input
                      {...register("customerDetails.phone")}
                      type="number"
                      required
                      className="form-control"
                    />
                    <ErrorText
                      error={formState.errors.customerDetails?.phone?.message}
                    />
                  </div>
                </div>
                <div className="col-12 my-2">
                  <div className="form-group with-icon">
                    <label className=" mb-0">Email</label>
                    <input
                      {...register("customerDetails.email")}
                      type="email"
                      className="form-control"
                    />
                    <ErrorText
                      error={formState.errors.customerDetails?.email?.message}
                    />
                  </div>
                </div>
                <div className="col-12 my-2 text-end">
                  <LoadingButton
                    loading={requestLoading}
                    onClick={handleSubmit(onSubmit)}
                    minWidth="60px"
                  >
                    {isLoogedIn ? "Submit" : "Create User"}
                  </LoadingButton>
                </div>
              </div>
            </form>
          </div>
          <ReCaptcha
            setToken={(token: string) => {
              setCaptchaToken(token);
            }}
            myRef={reCaptchaRef}
          />
        </Modal.Body>
      </Modal>
      <div></div>
    </>
  );
};
